import { Component, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Client } from 'app/entities';
import { SubscriptionRestrictionService } from 'app/services/subscription-restriction.service';
import { Subject } from 'rxjs';
import { openClientFormDialog } from '../client-form-dialog/client-form-dialog.component';

@Component({
  selector: 'app-card-drop-down-client-create',
  templateUrl: './card-drop-down-client-create.component.html',
})
export class CardDropDownClientCreateComponent {

  @Output() onCreated = new Subject<Client>();
  /** Cadastro rápido (nome e WhatsApp), usado pelo orçamento (ORCA-1922). */
  @Input() compact = false;

  constructor(
    private _subscriptionRestrictionService: SubscriptionRestrictionService,
    private _dialog: MatDialog,
  ) { }

  open() {
    if (this._subscriptionRestrictionService.checkFeatureLimitAndShowDialog("clientes")) {
      return;
    }
    openClientFormDialog(this._dialog, { compact: this.compact }).subscribe((client) => {
      if (client) {
        this.onCreated.next(client);
      }
    });
  }

}
